/**
 * The query-string serializer for the ORVAL-GENERATED API client.
 *
 * Axios's built-in serializer writes an array as `?status[]=due&status[]=overdue`.
 * FastAPI declares a multi-value filter as `list[str] = Query(...)` and reads it
 * from REPEATED BARE KEYS (`?status=due&status=overdue`) — it has no parameter
 * named `status[]`, so the value binds `None` and the filter silently disappears:
 * HTTP 200, a plausible unfiltered page, nothing logged. Roughly twenty generated
 * `*Params` types already declare `string[]` query params, so this is wired onto
 * the shared axios instance rather than per call site.
 *
 * Falsy handling matches `buildParams` (the hand-written services' equivalent), so
 * the two client layers put the same request on the wire:
 * - `undefined` / `null` / `''` are skipped — "not filtering by this".
 * - `0` and `false` ARE sent: `offset=0` is page 1 and `include_undated_due=false`
 *   is a real instruction, not the absence of one.
 * - An empty array is skipped rather than emitted as a bare `status=`, which the
 *   server would parse as the one-element list `['']`.
 *
 * Pinned by `__tests__/arrayParamSerialization.test.ts`.
 */
export function serializeQueryParams(params: Record<string, unknown>): string {
  const sp = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue;
    if (Array.isArray(value)) {
      for (const item of value) {
        if (item === undefined || item === null || item === '') continue;
        sp.append(key, String(item));
      }
    } else {
      sp.append(key, String(value));
    }
  }
  return sp.toString();
}
